/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};
Shopify.theme.jsPromotionBar = {
  init: function($section) {
    
    // Add settings from schema to current object
    Shopify.theme.jsPromotionBar = $.extend(this, Shopify.theme.getSectionData($section));
    this.section = $section;
    this.toggled = true;
    this.section.find('.promotions-bar__button').off('click').on('click', this.toggleDrawer.bind(this));
    this.section.find('button[data-modal]').off('click').on('click', this.popup.bind(this));
    this.section.find('button.close').off('click').on('click', this.close.bind(this));
    this.createSlider();
    this.handleMobileDevices();

    setTimeout(() => {
      this.handleMobileDevices();
    }, 100);
  },
  showThemeEditorState: function(id, $section) {
    this.section.addClass('promotions-bar--force-show');
  },
  hideThemeEditorState: function(id, $section) {
    this.section.removeClass('promotions-bar--force-show');
  },
  toggleDrawer: function() {
    this.section.animate({
      bottom: this.toggled ? 0 : -this.section.find('.promotions-bar__items').outerHeight()
    }, 'fast', this.updateButton.bind(this));
  },
  updateButton: function() {
      this.toggled = !this.toggled;
      let button = this.section.find('.promotions-bar__button'),
          header = button.find('strong'),
          subHeader = button.find('small');
      if(this.toggled){
        header.text(header.data('default'));
        subHeader.text(subHeader.data('default'));
        button.find('.icon').hide();
        button.find('.icon.open').show();
      }else{
        if(header.data('alt')){
          header.text(header.data('alt'));
        }
        subHeader.text(subHeader.data('alt'));
        button.find('.icon').hide();
        button.find('.icon.close').show();
      }
  },
  createSlider: function() {
    let slider = this.section.find('.promotions-bar__carousel');
    slider.flickity({
      cellAlign: 'center',
      contain: true,
      resize: true,
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false
    });
  },
  popup: function(e) {
    let popupContent = this.section.find('.popup__content');
    popupContent.html(this.section.find($(e.currentTarget).data('content')).html());
    $.fancybox.open({
      src: '[data-promotion-popup]',
      type: 'inline',
      opts: {
        baseClass: 'popup-modal',
        hash: false,
        infobar: false,
        toolbar: false,
        smallBtn: false,
        touch: {
          vertical: false,
          momentum: false
        },
        beforeShow: () => {
          // Remove previous slides (fix for theme editor)
          $('.popup-modal .fancybox-slide').empty();
        },
        afterShow: () => {
          // After content is loaded, attach event listener for custom close icon
          $(document).on('click touchstart', '.popup__close', () => {
            this.close();
          });
        },
        beforeClose: () => {
          // Prevent duplicate triggers for close icon click
          $('.popup__close').off();
        }
      }
    });
  },
  close: function() {
    $.fancybox.close($('[data-promotion-popup]'));
  },

  handleMobileDevices: function() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
    if (isMobile) {
      var promotionsButton = this.section.find('.promotions-bar__button')[0];
      var offersSection = this.section.find('.my-offers-section')[0]; 
  
      this.updateMobileLayout(promotionsButton, offersSection);
  
      promotionsButton.addEventListener('click', () => {
        this.updateMobileLayout(promotionsButton, offersSection);
      });
    }
  },
  
  handleMobileDevices: function() {
    var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
  
    if (isMobile) {
      var promotionsButton = this.section.find('.promotions-bar__button')[0];
  
      this.applyFixedPositioning(promotionsButton);
  
      promotionsButton.addEventListener('click', () => {
        setTimeout(() => {
          this.updateMobileButtonStyle(promotionsButton);
        }, 10);
      });
  
      var observer = new MutationObserver(() => {
        this.updateMobileButtonStyle(promotionsButton);
      });
      observer.observe(promotionsButton, { childList: true, subtree: true });
    }
  },
  
  applyFixedPositioning: function(button) {
    button.style.position = 'fixed';
    button.style.bottom = '0';
    button.style.left = '0';
    button.style.right = '0';
    button.style.zIndex = '1000';
  },
  
  updateMobileButtonStyle: function(button) {
    var buttonText = button.textContent.trim().toUpperCase();
    
    if (buttonText.includes("ADULT ACTIVEWEAR AT 995")) {
      this.applyFixedPositioning(button);
    } else {
      button.style.position = '';
      button.style.bottom = '';
      button.style.left = '';
      button.style.right = '';
      button.style.zIndex = '';
    }
  },
  
  

  unload: function($section) {
    this.section.find('.promotions-bar__button').off();
    let $slider = this.section.find('.flickity-enabled');
    $slider.flickity('destroy');
  }
}

/******/ })()
;
